var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpb-banner",style:(`background-image: url(${_vm.data.backgroundImage}); --kpb-banner-background-size: ${_vm.backgroundSize}; --kpb-banner-background-position: ${_vm.backgroundPosition}; --kpb-banner-background-color: ${_vm.backgroundColor}`)},[_vm._t("top"),_vm._t("default"),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }